import { useEffect, useMemo, useState } from 'react';
import { MaterialReactTable, type MRT_ColumnDef, } from 'material-react-table';
import { Box, Stack } from '@mui/material';
import axios from 'axios';
import { API_PATH } from '../../../App';
import { getAxiosConfig } from '../../../helpers/AuthHelper';
import TableLoader from '../GlobalComponents/TableLoader';

interface NicehashEmitterData {
    id: number;
    workerId: string;
    date: string;
    expense: number;
    orderId: string;
    algorithm: string;
}

interface NicehashEmitterProps {
    fromDate: Date | null;
    setFromDate: (date: Date | null) => void;
    toDate: Date | null;
    setToDate: (date: Date | null) => void;
    searchTrigger: boolean;
}

const NicehashEmitter: React.FC<NicehashEmitterProps> = ({ fromDate, toDate, searchTrigger }) => {
    const [rows, setRows] = useState<NicehashEmitterData[]>([]);
    const [tableLoader, setTableLoader] = useState(false);

    useEffect(() => {
        handleSearch();
    }, [searchTrigger,toDate]);

    const formatDate = (date: Date | null) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const fetchNicehashEmitterData = (from: string, to: string) => {
        setTableLoader(true);
        axios.get(`${API_PATH}/finance/report/nicehashemitterlist?from=${from}&to=${to}`, getAxiosConfig())
            .then(response => {
                setRows(response.data);
            })
            .catch(error => {
                console.error('Error fetching nicehash emitter data:', error);
            })
            .finally(() => setTableLoader(false));
    };

    const handleSearch = () => {
        const from = formatDate(fromDate);
        const to = formatDate(toDate);
        fetchNicehashEmitterData(from, to);
    };

    // const handleDownloadCSV = () => {
    //     const csvRows = [
    //         columns.map(col => col.header).join(','),
    //         ...rows.map(row => {
    //             return columns.map(col => {
    //                 const value = row[col.accessorKey as keyof NicehashEmitterData];
    //                 return value !== undefined ? value : '';
    //             }).join(',');
    //         })
    //     ];

    //     const csvString = csvRows.join('\n');
    //     const blob = new Blob([csvString], { type: 'text/csv' });
    //     const url = window.URL.createObjectURL(blob);

    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = `nicehash_emitter_data_${formatDate(new Date())}.csv`;
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);

    //     window.URL.revokeObjectURL(url);
    // };

    const totalExpense = useMemo(
        () => rows.reduce((acc, curr) => acc + (curr.expense || 0), 0),
        [rows]
    );

    const columns = useMemo<MRT_ColumnDef<NicehashEmitterData>[]>(
        () => [
            { accessorKey: 'id', header: 'ID', size: 80 },
            { accessorKey: 'workerId', header: 'Emitter', size: 150 },
            { accessorKey: 'date', header: 'Date', size: 120 },
            { accessorKey: 'orderId', header: 'Order ID', size: 250 },
            { accessorKey: 'algorithm', header: 'Algorithm', size: 150 },
            {
                accessorKey: 'expense',
                header: 'Expense (BTC)',
                size: 150,
                Cell: ({ row }) => Number(row.original.expense).toFixed(8),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {totalExpense.toLocaleString('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 10,
                            })}
                        </Box>
                    </Stack>
                ),
            },
        ],
        [totalExpense]
    );

    return (
        <>
            {/* <Grid container spacing={1} sx={{ mb: 2 }} alignItems="center">
                <Grid item xs={12} sm="auto">
                    <Button variant="contained" size="small" onClick={handleSearch}>
                        <Search />
                    </Button>
                </Grid>
                <Grid item xs={12} sm="auto">
                    <Button variant="contained" size="small" onClick={handleDownloadCSV}>
                        <Download />
                    </Button>
                </Grid>
            </Grid> */}

            {tableLoader ? (
                <TableLoader />
            ) : (
                <MaterialReactTable
                    columns={columns}
                    data={rows}
                />
            )}
        </>
    );
};

export default NicehashEmitter;
